import { asView } from '@esui/core';
import { spread } from '@esui/core/utils/spread.js';
import '@material/mwc-icon';
import { html } from 'lit';
import { ref } from 'lit/directives/ref.js';
import { styleMap } from 'lit/directives/style-map.js';

export { Icon as MdcIcon } from '@material/mwc-icon';

export const [Icon] = asView({
  Props: class {
    name = '';
  },

  mapBuilder: IconBuilder => (name: string) => IconBuilder().name(name),

  template(props, { bindings, styles, elementRef }) {
    return html`
      <mwc-icon
        ${spread(bindings)}
        style="${styleMap(styles)}"
        ${ref(elementRef)}
      >
        ${props.name}
      </mwc-icon>
    `;
  },
});
